import type { OverviewResponse } from "contracts/api/dashboard/responses";
import { Show } from "solid-js";
import {
  pageDisplayLabel,
  rawPagePath,
} from "../pages/boundaries/page-label.parser";
import { pageDetailHref } from "./pageDetailNavigation";
import { buildPageContext } from "./scanExperienceModel";
import { pageContentFitnessScore } from "./scanModel";

export function SinglePageScanState(props: {
  data: OverviewResponse;
  websiteId: string;
}) {
  const page = () => props.data.pages[0];
  const context = () => (page() ? buildPageContext(props.data, page()) : null);
  const detailHref = () =>
    page()
      ? pageDetailHref(props.websiteId, page().id, { source: "pages" })
      : `/w/${props.websiteId}/scan/pages`;

  return (
    <section class="signal-single-page-state">
      <span class="signal-mini-kicker">Single-page scan</span>
      <h3>There are no site relationships to map.</h3>
      <p>
        This scan assessed one page, so the page record is the useful place to
        inspect its score, findings and evidence.
      </p>
      <Show when={page()}>
        {(currentPage) => (
          <div class="signal-single-page-card">
            <div>
              <strong>
                {pageDisplayLabel(currentPage(), props.data.site)}
              </strong>
              <span class="mono">{rawPagePath(currentPage())}</span>
            </div>
            <dl>
              <div>
                <dt>Content Fitness</dt>
                <dd>{pageContentFitnessScore(currentPage()) ?? "--"}</dd>
              </div>
              <div>
                <dt>Linked issues</dt>
                <dd>{context()?.issues.length ?? 0}</dd>
              </div>
              <div>
                <dt>Priority state</dt>
                <dd>
                  {context()?.strategic
                    ? "Linked to priority issue"
                    : "No priority issue linked"}
                </dd>
              </div>
            </dl>
            <a class="signal-primary-link" href={detailHref()}>
              Inspect page
            </a>
          </div>
        )}
      </Show>
    </section>
  );
}
